export default __webpack_public_path__ + "static/media/Blue geode1.a0decfb7.jpg";